import type { ScriptLine } from "../shared3d/script";
import { SCENE, FPS } from "./constants";

export const hook: ScriptLine[] = [
  {
    scene: "hook",
    fromSec: 0,
    durSec: 5,
    caption: "One database. Every customer's data sharing the same tables.",
  },
  {
    scene: "hook",
    fromSec: 5,
    durSec: 5,
    caption: "So how does one tenant never see another tenant's rows?",
  },
  {
    scene: "hook",
    fromSec: 10,
    durSec: 5,
    caption: "The answer isn't in your app code — it's in Postgres itself.",
  },
];

export const problem: ScriptLine[] = [
  {
    scene: "problem",
    fromSec: 0,
    durSec: 6,
    caption: "The obvious fix: add WHERE tenant_id = ? to every query.",
  },
  {
    scene: "problem",
    fromSec: 6,
    durSec: 7,
    caption:
      "But that puts security in every developer's hands, on every query.",
  },
  {
    scene: "problem",
    fromSec: 13,
    durSec: 8,
    caption: "Forget the clause once — one endpoint, one join, one script —",
  },
  {
    scene: "problem",
    fromSec: 21,
    durSec: 9,
    caption:
      "and Tenant A is suddenly reading Tenant B's data. A silent breach.",
  },
];

export const intuition: ScriptLine[] = [
  {
    scene: "intuition",
    fromSec: 0,
    durSec: 7,
    caption: "Think of an apartment building.",
  },
  {
    scene: "intuition",
    fromSec: 7,
    durSec: 7,
    caption: "You don't trust every tenant to lock their own door.",
  },
  {
    scene: "intuition",
    fromSec: 14,
    durSec: 6,
    caption: "The building enforces the lock — at the door, every time.",
  },
];

export const approach: ScriptLine[] = [
  {
    scene: "approach",
    fromSec: 0,
    durSec: 7,
    caption: "Postgres Row-Level Security is that building.",
  },
  {
    scene: "approach",
    fromSec: 7,
    durSec: 9,
    caption:
      "Turn it on and the database filters every row of every query — automatically.",
  },
  {
    scene: "approach",
    fromSec: 16,
    durSec: 9,
    caption: "It doesn't matter which code path runs. The engine checks first.",
  },
];

export const code1: ScriptLine[] = [
  {
    scene: "code1",
    fromSec: 0,
    durSec: 8,
    caption: "Here's the actual policy from EAKC's migration 194.",
  },
  {
    scene: "code1",
    fromSec: 8,
    durSec: 10,
    caption: "USING decides which rows you're allowed to read.",
  },
  {
    scene: "code1",
    fromSec: 18,
    durSec: 11,
    caption: "WITH CHECK decides which rows you're allowed to write.",
  },
  {
    scene: "code1",
    fromSec: 29,
    durSec: 11,
    caption:
      "Both compare the row's tenant_id to your token's claim — auth.jwt().",
  },
];

export const code2: ScriptLine[] = [
  {
    scene: "code2",
    fromSec: 0,
    durSec: 9,
    caption: "Two details make this airtight.",
  },
  {
    scene: "code2",
    fromSec: 9,
    durSec: 11,
    caption:
      "One: it fails closed. RLS on, no policy, means deny everything — not allow.",
  },
  {
    scene: "code2",
    fromSec: 20,
    durSec: 11,
    caption:
      "Two: only the trusted server role bypasses it — the single admin writer.",
  },
  {
    scene: "code2",
    fromSec: 31,
    durSec: 9,
    caption: "Every normal query is scoped to one tenant, by the database.",
  },
];

export const payoff: ScriptLine[] = [
  {
    scene: "payoff",
    fromSec: 0,
    durSec: 8,
    caption: "So 'you only see your own data' isn't a promise the app makes.",
  },
  {
    scene: "payoff",
    fromSec: 8,
    durSec: 11,
    caption:
      "It's a guarantee the database enforces — you can't query another tenant's rows.",
  },
  {
    scene: "payoff",
    fromSec: 19,
    durSec: 11,
    caption: "That's what 100% isolated, 100% relevant actually means.",
  },
];

export const outro: ScriptLine[] = [
  {
    scene: "outro",
    fromSec: 0,
    durSec: 7,
    caption: "EAKC — multi-tenant by construction.",
  },
  {
    scene: "outro",
    fromSec: 7,
    durSec: 7,
    caption: "Grounded in the real migration, not marketing.",
  },
  {
    scene: "outro",
    fromSec: 14,
    durSec: 6,
    caption: "Code's in the description.",
  },
];

export const byScene: Record<string, ScriptLine[]> = {
  hook,
  problem,
  intuition,
  approach,
  code1,
  code2,
  payoff,
  outro,
};

/** Flattened global-second timeline for the VO generator. */
export const voLines: ScriptLine[] = Object.entries(byScene).flatMap(
  ([k, lines]) =>
    lines.map((l) => ({
      ...l,
      fromSec: SCENE[k as keyof typeof SCENE].start / FPS + l.fromSec,
    })),
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
